export enum QueryKeyEnum {
    SSO_PROVIDER_TYPES = "SSO_PROVIDER_TYPES",
    SSO_CONFIGURATIONS = "SSO_CONFIGURATIONS",
    INTEGRATION_CONFIGURATIONS = "INTEGRATION_CONFIGURATIONS",
    USERS = "USERS",
}
